import React from "react";
import { LineChart, axisClasses } from "@mui/x-charts";

interface MuiLineChartProps {
  xLabels: string[];
  yData: number[];
  label: string;
  color?: string;
  height?: number;
}

const MuiLineChart: React.FC<MuiLineChartProps> = ({
  xLabels,
  yData,
  label,
  color = "#3e59e3",
  height = 300,
}) => {
  return (
    <LineChart
      height={height}
      xAxis={[{ scaleType: "point", data: xLabels }]}
      series={[{ data: yData, label, color }]}
      sx={{
        [`& .${axisClasses.left} .MuiChartsAxis-tickLabel`]: {
          fontSize: 12,
        },
      }}
    />
  );
};

export default MuiLineChart;
